import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { SimpleResponse } from '@/types/common.ts';
import { INTEGRATION_CONFIG_EMAIL_ROUTES_KEY } from '@/utils/queryKeys.ts';
import { get_email_alias_url } from '@/utils/urls.ts';

type DeleteEmailAliasParams = {
  stepId: string;
  routeId: string;
};

const useDeleteEmailAlias = (): UseMutationResult<SimpleResponse, AxiosError, DeleteEmailAliasParams> => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ stepId, routeId }) => {
      const response = await apiClient.delete<SimpleResponse>(get_email_alias_url(automationId, stepId, routeId));
      return response.data;
    },
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: INTEGRATION_CONFIG_EMAIL_ROUTES_KEY(automationId, variables.stepId),
      });
    },
  });
};

export default useDeleteEmailAlias;
